import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { hideStaffToast, showStaffToast } from '../../toast/actions/addStaffToast.action';
import {
    ADD_MULTIPLE_STAFF_FAILURE,
    ADD_MULTIPLE_STAFF_REQUEST,
    ADD_MULTIPLE_STAFF_SUCCESS,
    ADD_STAFF_FAILURE,
    ADD_STAFF_REQUEST,
    ADD_STAFF_SUCCESS,
    DELETE_STAFF_FAILURE,
    DELETE_STAFF_REQUEST,
    DELETE_STAFF_SUCCESS,
    EDIT_STAFF_FAILURE,
    EDIT_STAFF_REQUEST,
    EDIT_STAFF_SUCCESS,
    GET_STAFF_FAILURE,
    GET_STAFF_REQUEST,
    GET_STAFF_SUCCESS,
} from '../constants/staff.constants';

interface staffData {
    id?: string;
    email?: string;
    fullName?: string;
    password?: string;
    role?: string;
    image_url?: string;
    name?: string
}
// { email: any; name: any; image_url: string; password: string; role: any; }
// Get Staff
const getStaffRequest = () => {
    return {
        type: GET_STAFF_REQUEST,
    };
};

const getStaffSuccess = (staffData: AnyIfEmpty<object>) => {
    return {
        type: GET_STAFF_SUCCESS,
        payload: staffData,
    };
};

const getStaffFailure = (staffError: AnyIfEmpty<object>) => {
    return {
        type: GET_STAFF_FAILURE,
        payload: staffError,
    };
};

// Add Staff
const addStaffRequest = () => {
    return {
        type: ADD_STAFF_REQUEST,
    };
};
const addStaffSuccess = (staffData: AnyIfEmpty<object>) => {
    return {
        type: ADD_STAFF_SUCCESS,
        payload: staffData,
    };
};
const addStaffFailure = (staffError: AnyIfEmpty<object>) => {
    return {
        type: ADD_STAFF_FAILURE,
        payload: staffError,
    };
};

// Edit Staff
const editStaffRequest = () => {
    return {
        type: EDIT_STAFF_REQUEST,
    };
};
const editStaffSuccess = (staffData: AnyIfEmpty<object>) => {
    return {
        type: EDIT_STAFF_SUCCESS,
        payload: staffData,
    };
};
const editStaffFailure = (staffError: AnyIfEmpty<object>) => {
    return {
        type: EDIT_STAFF_FAILURE,
        payload: staffError,
    };
};

// Delete Staff
const staffDeleteRequest = () => {
    return {
        type: DELETE_STAFF_REQUEST,
    };
};
const staffDeleteSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: DELETE_STAFF_SUCCESS,
        payload: data,
    };
};
const staffDeleteFailure = (errMsg: AnyIfEmpty<object>) => {
    return {
        type: DELETE_STAFF_FAILURE,
        payload: errMsg,
    };
};

// Add Multiple Staff
const addMultipleStaffRequest = () => {
    return {
        type: ADD_MULTIPLE_STAFF_REQUEST,
    };
};
const addMultipleStaffSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: ADD_MULTIPLE_STAFF_SUCCESS,
        payload: data,
    };
};
const addMultipleStaffFailure = (errMsg: AnyIfEmpty<object>) => {
    return {
        type: ADD_MULTIPLE_STAFF_FAILURE,
        payload: errMsg,
    };
};

// Get Staff Dispatch
export const getStaff = () => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getStaffRequest());
        return axios
            .get(`/admin/staff`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getStaffSuccess(response.data.staffs));
                } else {
                    throw new Error(response.data.message);
                }
            })
            .catch((error) => dispatch(getStaffFailure(error)));
    };
};

// export const uploadImages = async (imageFiles: File[], folderName: string) => {
//     const image_url: string[] = [];
//     const formData = new FormData();
//     imageFiles.map((file: File) => formData.append('file', file));
//     const imageData = await axios.post(`/admin/upload/file?folderName=${folderName}`, formData);
//     if (imageData?.data?.length > 0) {
//         imageData.data.map((image: { location: string; }) => image_url.push(image.location));
//     }
//     return image_url;
// };

// Add Staff Dispatch


export const uploadImages = async (imageFiles: File[], folderName: string) => {
    const image_url: string[] = [];
    const formData = new FormData();
  
    imageFiles.forEach((file: File) => formData.append('file', file));
  
    try {
      const imageData = await axios.post(
        `/admin/upload/file?folderName=${folderName}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data', // ✅ force correct type
          },
        }
      );
  
      if (Array.isArray(imageData?.data)) {
        imageData.data.forEach((image: { location: string }) =>
          image_url.push(image.location)
        );
      }
  
      return image_url;
    } catch (error: any) {
      throw error;
    }
  };
  

export const addStaff = (staffData: staffData) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(addStaffRequest());
        return axios
            .post(`/admin/staff`, staffData)
            .then((response) => {
                dispatch(getStaff());
                dispatch(showStaffToast());
                dispatch(addStaffSuccess(response.data));
                setTimeout(() => dispatch(hideStaffToast()), 4000);
            })
            .catch((error) => dispatch(addStaffFailure(error)));
    };
};

// Edit Staff Dispatch
export const editStaff = (staffData: staffData) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(editStaffRequest());
        return axios
            .put(`/admin/staff/${staffData.id}`, staffData)
            .then((response) => {
                dispatch(getStaff());
                dispatch(editStaffSuccess(response.data));
                dispatch(showStaffToast());
                setTimeout(() => dispatch(hideStaffToast()), 4000);
            })
            .catch((error) => dispatch(editStaffFailure(error)));
    };
};

// Delete Staff
export const deleteStaff = (id: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(staffDeleteRequest());
        await axios
            .delete(`/admin/staff/${id}`)
            .then((response) => {
                dispatch(getStaff());
                dispatch(staffDeleteSuccess(response.data));
            })
            .catch((error) => dispatch(staffDeleteFailure(error)));
    };
};

// Add Multiple Staff Dispatch
export const addMultipleStaff = (setPercentage: (arg0: number) => void, csvFile: string | Blob) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        const formData = new FormData();
        formData.append('file', csvFile);
        dispatch(addMultipleStaffRequest());
        return axios
            .post(`/account/staff/upload-csv`, formData, {
                onUploadProgress: (e) => {
                    const percentCompleted = Math.round((e.loaded * 100) / e.total);
                    setPercentage(percentCompleted);
                },
            })
            .then((response) => {
                dispatch(getStaff());
                dispatch(showStaffToast());
                dispatch(addMultipleStaffSuccess(response.data));
                setTimeout(() => dispatch(hideStaffToast()), 4000);
            })
            .catch((error) => dispatch(addMultipleStaffFailure(error)));
    };
};


export const uploadFile = async (file: File, folderName: string) => {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`/admin/upload/file?folderName=${folderName}`, formData)
        .then(response => {
            const imageData = response.data;
            if (imageData?.length > 0) {
                // imageData.forEach((image: { location: string }) => image_url.push(image.location));
                return imageData[0].location;
            } else {
                return null
            }
        })
        .catch(error => {
            console.error('Error uploading file:', error);
            return [];
        });
};